import { memo } from 'react'

import { ConfirmationDialog } from '@collaborate-health/uikit'

export interface AnnouncementDeleteConfirmationDialogProps {
  open: boolean
  onClose: () => void
  onSubmit: () => void
}

const AnnouncementDeleteConfirmationDialog: React.FC<AnnouncementDeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  return (
    <ConfirmationDialog
      isOpen={open}
      onCloseDialog={onClose}
      onSubmit={onSubmit}
      title='Are you sure you want to delete this announcement?'
      dialogMessage='This action cannot be undone'
      submitButtonColor='error'
      submitButtonText='Delete'
    />
  )
}

export default memo(AnnouncementDeleteConfirmationDialog)

